// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__hAreS","noPaddingX":"SectionHeader_noPaddingX__Gl7nn"};